





















import request from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ConfirmModal extends Vue {
  @Prop({ required: true })
  public title!: string;
  @Prop({ required: true })
  public text!: string;
  @Prop({ required: true })
  public visible!: boolean;

  public cancel() {
    this.$emit('cancel');
  }

  public confirm() {
    this.$emit('confirm');
  }
}
